var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotEyesInputScore = function SvgShotEyesInputScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "shotEyesInputScore_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".shotEyesInputScore_svg__st0{fill:none;stroke:#333;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 21.2H4c-.6 0-1-.4-1-1V3.8c0-.6.4-1 1-1h16c.6 0 1 .4 1 1v4.9M13.5 19.2l5.2-7.2 2.2 1.8-5.5 7.5h-2zM7 10.2h6M10 7.2v6",
    className: "shotEyesInputScore_svg__st0"
  })));
};
export default SvgShotEyesInputScore;